import { Route, Routes, useLocation } from "react-router-dom";
import FrontLayout from "../layouts/FrontLayout";
import BlankLayout from "../layouts/BlankLayout";

import { map } from "lodash";
import otherRoutes from "./other.routes.config";
import PublicRouteWrapper from "./publicRouteWrapper";
import { publicRoutes } from "./public.route.component.config";
import { useEffect, useState } from "react";
import { getOS, getBrowser } from "@/utils/common";
import ScrollToTop from "@/components/common/ScrollToTop";

const FrontRoutes = () => {

    const location = useLocation();
    const [deviceInfo, setDeviceInfo] = useState({
        platform: 'unknown-os',
        platformVersion: 'Unknown',
        browser: 'unknown-browser',
        browserVersion: 'Unknown'
    });

    useEffect(() => {

        const detectDevice = async () => {
            const osInfo = await getOS();
            const browserInfo = getBrowser();

            const info = {
                ...osInfo,
                ...browserInfo
            };

            setDeviceInfo(info);
            const bodyElement = document.body;
            const pathParts = location.pathname.split("/").filter(Boolean);

            let routeClasses = [];
            if (pathParts.length === 0) {
                routeClasses.push("home");
            } else if (pathParts.length === 1) {
                //routeClasses.push(pathParts[0]);
                routeClasses = pathParts.map((part) => `page-${part}`);
            } else {
                routeClasses = pathParts;
            }
            bodyElement.className = "";
            bodyElement.classList.add(...routeClasses, info.platform, info.browser);
        };

        detectDevice();
    }, [location.pathname]);

    return (
        <>
            <ScrollToTop />
            <Routes>
                <Route element={<FrontLayout deviceInfo={deviceInfo} />}>
                    {
                        publicRoutes && map(publicRoutes, (value, key) => (
                            <Route path={value.path} element={
                                <PublicRouteWrapper
                                    element={value.element}
                                    restricted={value.restricted}

                                />
                            } key={key} />
                        ))
                    }
                </Route>

                {/* 404 for frontend */}
                <Route element={<BlankLayout />}>
                    {
                        otherRoutes && map(otherRoutes, (val, k) => (
                            <Route path={val.path} element={val.element} key={k} />
                        ))
                    }
                </Route>
            </Routes>
        </>

    )

}

export default FrontRoutes;